// 全局事件总线（Vue 2）
// 用于跨组件通信，如隐私政策弹窗、Cookie 设置等全局弹窗的触发
import Vue from 'vue'

export const eventBus = new Vue()

export default eventBus
